import { getNextRoute } from '@shared/helpers/Route'

import basketStore from '@shared/store/basket'
import useBasket from '@shared/hooks/useBasket'

import { ROUTE_INDEX, ROUTE_NAME } from '@shared/config/constants'
import { ANSWER } from '@shared/config/tracker'

export default [
  {
    path: 'persons',
    children: [
      {
        beforeEnter: (to, _from, next) => {
          const { isStaticBasket } = useBasket()

          if (isStaticBasket.value) {
            next({
              name: getNextRoute(basketStore.basket),
              params: {
                lang: to.params.lang,
              },
            })
          } else {
            next()
          }
        },
        component: () => import('@shared/modules/Dvp/screens/Persons/ScreenPersons'),
        meta: {
          index: ROUTE_INDEX.PERSONS,
          secured: true,
        },
        name: ROUTE_NAME.PERSONS,
        path: ':personId?/:fieldName?/',
        props: route => ({
          personId: route.params.personId,
          fieldName: route.params.fieldName,
        }),
      },
      {
        component: () => import('@shared/modules/Dvp/screens/Persons/ScreenImmigrant'),
        meta: {
          index: ROUTE_INDEX.PERSONS_IMMIGRANT,
          navigation: false,
          secured: true,
          tracking: {
            basket: {
              immigrant: ANSWER.YES,
            },
          },
        },
        name: ROUTE_NAME.PERSONS_IMMIGRANT_PAST,
        path: 'immigrant-past',
      },
      {
        component: () => import('@shared/modules/Dvp/screens/Persons/ScreenImmigrant'),
        meta: {
          index: ROUTE_INDEX.PERSONS_IMMIGRANT,
          navigation: false,
          secured: true,
          tracking: {
            basket: {
              immigrant: ANSWER.YES,
            },
          },
        },
        name: ROUTE_NAME.PERSONS_IMMIGRANT_FUTURE,
        path: 'immigrant-future',
      },
    ],
  },
]
